import { IApplicationState } from '../../../../../../../../types/types';
import { connect } from 'react-redux';
import { IChatsTogglerHOCProps } from './types';
import { onChange } from './events/onChange';
import { ISectionTogglerEvents, ISectionTogglerFields } from '../../../../../../base/components/SectionToggler/types';
import { SectionToggler } from '../../../../../../base/components/SectionToggler/SectionToggler';
import { getSectionType } from '../../../../selectors/getSectionType';
import { ESettingsSectionType } from '../../../../../../base/components/SettingsSection/types';
import { showBoardLimitSnackbarIfNeeded } from '../../../../../effects/showBoardLimitSnackbarIfNeeded';
import { getChatDashboardSettingsByBoardId } from 'app/store/model/chatDashboardSettings/selectors/getChatDashboardSettingsByBoardId';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: IChatsTogglerHOCProps
): ISectionTogglerFields => {
    const sectionType = getSectionType(state, boardId, null, null);
    const isDisabled = sectionType === ESettingsSectionType.READONLY;
    const isDisallowed = sectionType === ESettingsSectionType.DISALLOW;
    return {
        checked: getChatDashboardSettingsByBoardId(state, boardId).enabled,
        isDisabled,
        isDisallowed,
    };
};

const mapDispatchToProps = (
    dispatch: any,
    { boardId }: IChatsTogglerHOCProps
): ISectionTogglerEvents => {
    return {
        onChange: () => dispatch(onChange(boardId)),
        onClickDisabled: () => dispatch(showBoardLimitSnackbarIfNeeded()),
    }
};

export const ChatsTogglerHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(SectionToggler);

ChatsTogglerHOC.displayName = 'ChatsTogglerHOC';
